<script setup>
import { debounce } from '@/utils';
import { inject, ref } from 'vue';

const emit = defineEmits(['fetching']);
const dataView = inject('dataView');
const searchTerm = ref('');
const submit = () => {
    if (searchTerm.value) {
        dataView.activeView.setSearch(searchTerm.value);
    } else {
        dataView.activeView.clearSearch();
    }

    emit('fetching', true);
    dataView.activeView.fetch().finally(() => emit('fetching', false));
}

const debouncedSubmit = debounce(submit);
</script>

<template>
    <app-form class="min-w-0" :submit-using="submit">
        <app-form-input
            name="search"
            type="search"
            placeholder="Enter search keyword"
            hide-label
            @update:state="debouncedSubmit()"
            :default="dataView.activeView.search"
            v-model="searchTerm"
            />
    </app-form>
</template>
